import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'SupplierDisplay',
        caption: 'Supplier',
        width: COLUMN_SIZE.md1,
        allowSorting: true,
        allowEditing: false,
        alignment: 'left',
    },
    {
        dataField: 'Name',
        caption: 'Name',
        width: COLUMN_SIZE.lg0,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'Invoice',
        caption: 'Allocated invoice',
        width: COLUMN_SIZE.md1,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'RFC',
        caption: 'RFC',
        width: COLUMN_SIZE.md0,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'Type',
        caption: 'Type',
        width: COLUMN_SIZE.md0,
        allowSorting: true,
        allowEditing: false,
        alignment: 'left',
    },
    {
        dataField: 'AmountDisplay',
        caption: 'Amount',
        width: COLUMN_SIZE.md0,
        allowSorting: true,
        allowEditing: false,
        alignment: 'right'
    },
];
